import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of } from 'rxjs';
import { LoginService } from './pages/login/login.service';
import { setLoggedInUser } from './Store/request.actions';
import { setCognitoToken } from './Store/request.actions';
import { setCognitoTokenHolder } from './Store/cognito-token.holder';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private loginService : LoginService, private store : Store) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.loginService.checkLogin().pipe(
      map((response: any) => {
        if (response.status === 'authenticated') {
          this.store.dispatch(setCognitoToken({cognitoToken : response.cognitoToken}));
          setCognitoTokenHolder(response.cognitoToken);
          return true;
        } else {
          this.store.dispatch(setLoggedInUser({request : null}));
          this.store.dispatch(setCognitoToken({cognitoToken : null}));
          setCognitoTokenHolder(null);
          this.router.navigate(['/login']);
          return false;
        }
      }),
      catchError(() => {
        this.store.dispatch(setLoggedInUser({request : null}));
        this.store.dispatch(setCognitoToken({cognitoToken : null}));
        setCognitoTokenHolder(null);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
